export default "__VITE_ASSET__glQLAP9Z__"